import "bootstrap/js/dist/toast.js";

export default function () {
  $(".flash").each(function () {
    let message = $(this).attr("data-message");
    let type = $(this).attr("data-type");

    // Autohide
    let autohide = $(this).attr("data-autohide");
    if (typeof autohide === "undefined") {
      autohide = true;
    } else if (autohide === "false") {
      autohide = false;
    } else {
      autohide = true;
    }

    // Delay
    let delay = $(this).attr("data-delay");
    if (typeof delay !== "undefined") {
      delay = parseFloat(delay);
    } else {
      delay = 15000;
    }

    let fillColour;
    switch (type) {
      case "information":
        fillColour = "#62626C";
        break;
      case "warning":
        fillColour = "#EEA102";
        break;
      case "urgent":
        fillColour = "#EE4F61";
        break;
      default:
        fillColour = "";
    }
    const toast_container = document.createElement("div");

    toast_container.innerHTML = `
    <link href='https://fonts.googleapis.com/css?family=Inter' rel='stylesheet'>
    <div class='notification-container ${type}'>
        <div class='notification-icon'>
            ${
              type === "success"
                ? `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM12.1017 4.96492C12.2991 5.15976 12.3011 5.47766 12.1062 5.67497L6.81751 11.0306C6.62285 11.2277 6.30531 11.2299 6.10793 11.0355L3.89872 8.8597C3.70116 8.66512 3.69874 8.34722 3.89332 8.14966C4.0879 7.95209 4.4058 7.94967 4.60337 8.14425L6.45532 9.96824L11.3917 4.96938C11.5865 4.77207 11.9044 4.77007 12.1017 4.96492Z" fill="#61D783"/>
                  </svg>`
                : `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.78934C8.5 4.5132 8.27614 4.28934 8 4.28934C7.72386 4.28934 7.5 4.5132 7.5 4.78934V4.8C7.5 5.07615 7.72386 5.3 8 5.3C8.27614 5.3 8.5 5.07615 8.5 4.8V4.78934ZM8.5 7.46667C8.5 7.19053 8.27614 6.96667 8 6.96667C7.72386 6.96667 7.5 7.19053 7.5 7.46667V11.7333C7.5 12.0095 7.72386 12.2333 8 12.2333C8.27614 12.2333 8.5 12.0095 8.5 11.7333V7.46667Z" fill="${fillColour}"/>
                  </svg>`
            }
        </div>
        <div class='notification-label'>${message}</div>
        <div class='notification-close' data-dismiss='toast'><i class='fa fal fa-times'></i></div>
    </div>`;


    // Replace existing toast if one present, otherwise prepend to body
    if ($(".notification-container").length !== 0) {
      $(".notification-container").replaceWith(toast_container);
    } else {
      $("body").prepend(toast_container);
    }

    // Show toast
    $(".notification-container").toast({ autohide: autohide, delay: delay });
    return $(".notification-container").toast("show");
  });
}

// Title
// let title = $(this).attr("data-title");
// if (message === "You are already signed in.") {
//   title = "Welcome back!";
// } else if (typeof title === "undefined") {
//   title = "Ethos";
// }

// Build toast
// let toast = "<div class=\"toast mb-1\" role=\"alert\">";
// toast += "<div class=\"toast-header bg-primary-light\">";
// toast += "<span class=\"mr-auto font-weight-bold\">" + title + "</span>";
// toast += "<button type=\"button\" class=\"ml-2 mb-1 close\" data-dismiss=\"toast\" aria-label=\"Close\">";
// toast += "<span aria-hidden=\"true\">&times;</span>";
// toast += "</button></div>";
// toast += "<div class=\"toast-body\">";
// toast += message;
// toast += "</div></div>";

// export default function () {
//   $(".flash").each(function () {
//     let message = $(this).attr("data-message");

//     // Autohide logic
//     let autohide = $(this).attr("data-autohide") !== "false"; // Defaults to true unless explicitly false

//     // Delay logic
//     let delay = $(this).attr("data-delay");
//     delay = typeof delay !== "undefined" ? parseFloat(delay) : 15000; // Default to 15 seconds

//     // Title logic
//     let title = $(this).attr("data-title");
//     title = message === "You are already signed in." ? "Welcome back!" : title || "Ethos";

//     const type = "success";
//     const fillColour = "#EE4F61";
//     const toast_container = document.createElement("div");

//     toast_container.innerHTML = `
//       <link href='https://fonts.googleapis.com/css?family=Inter' rel='stylesheet'>
//       <div class='toast notification-container ${type}'>
//           <div class='notification-icon'>
//               ${
//                 type === "success"
//                   ? `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//                         <path fill-rule="evenodd" clip-rule="evenodd" d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM12.1017 4.96492C12.2991 5.15976 12.3011 5.47766 12.1062 5.67497L6.81751 11.0306C6.62285 11.2277 6.30531 11.2299 6.10793 11.0355L3.89872 8.8597C3.70116 8.66512 3.69874 8.34722 3.89332 8.14966C4.0879 7.95209 4.4058 7.94967 4.60337 8.14425L6.45532 9.96824L11.3917 4.96938C11.5865 4.77207 11.9044 4.77007 12.1017 4.96492Z" fill="#61D783"/>
//                     </svg>`
//                   : `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//                         <path fill-rule="evenodd" clip-rule="evenodd" d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.78934C8.5 4.5132 8.27614 4.28934 8 4.28934C7.72386 4.28934 7.5 4.5132 7.5 4.78934V4.8C7.5 5.07615 7.72386 5.3 8 5.3C8.27614 5.3 8.5 5.07615 8.5 4.8V4.78934ZM8.5 7.46667C8.5 7.19053 8.27614 6.96667 8 6.96667C7.72386 6.96667 7.5 7.19053 7.5 7.46667V11.7333C7.5 12.0095 7.72386 12.2333 8 12.2333C8.27614 12.2333 8.5 12.0095 8.5 11.7333V7.46667Z" fill="${fillColour}"/>
//                     </svg>`
//               }
//           </div>
//           <div class='notification-label'>${title} ${message}</div>
//       </div>`;

//     // Remove existing toast if present, otherwise add to body
//     if ($(".toast").length !== 0) {
//       $(".toast").replaceWith(toast_container);
//     } else {
//       $("body").prepend(toast_container);
//     }

//     // Add your custom show logic
//     $(toast_container).fadeIn(300); // Example of fade-in animation

//     if (autohide) {
//       setTimeout(() => {
//         $(toast_container).fadeOut(300, function () {
//           $(this).remove();
//         });
//       }, delay);
//     }

//     // $(toast_container).find(".close").on("click", function () {
//     //   $(toast_container).fadeOut(300, function () {
//     //     $(this).remove();
//     //   });
//     // });
//   });
// }
